import { Injectable } from '@angular/core';
import { LocalStorageService } from './localStorage.service';

@Injectable({
  providedIn: 'root',
})
export class AudioService {
  private audio: HTMLAudioElement;

  constructor(private _localStorage: LocalStorageService) {
    this.audio = new Audio();
  }

  playAudioOnInit(): void {
    const src = 'assets/sound/intuition.mp3';
    this.playAudio(src);
  }

  playAudioOnNewOrder(tuneOverride?: boolean): void {
    if (this.canPlayAudio(tuneOverride)) {
      const src = 'assets/sound/notification.mp3';
      this.playAudio(src);
    }
  }
  playAudioOnTableEvent(tuneOverride): void {
    if (this.canPlayAudio(tuneOverride)) {
      const src = 'assets/sound/new_notification.mpeg';
      this.playAudio(src);
    }
  }

  playAudioOnPaymentEvent(tuneOverride): void {
    if (this.canPlayAudio(tuneOverride)) {
      const src = 'assets/sound/new_payment.mpeg';
      this.playAudio(src);
    }
  }

  private playAudio(src: string): void {
    if (!src) {
      console.error('Audio source is required');
      return;
    }

    try {
      this.audio.src = src;
      this.audio.load();

      this.audio
        .play()
        .catch((error) => console.error('Error playing audio:', error));
    } catch (error) {
      console.error('Audio playback failed:', error);
    }
  }

  private isReactDevice(): boolean {
    return !!(this._localStorage.get('is_react') === '1');
  }

  private isForceStopSoundEnabled(): boolean {
    try {
      const settings = JSON.parse(
        this._localStorage.get('restaurant_settings') || '{}'
      );
      return !!settings?.sounds?.force_stop_sound;
    } catch (error) {
      console.error('Error parsing restaurant settings:', error);
      return false;
    }
  }

  private canPlayAudio(tuneOverride: boolean): boolean {
    let repeatNotification = this.isReactDevice();
    if (!tuneOverride) {
      repeatNotification = false;
    }
    return Boolean(
      this._localStorage.get('token') &&
        !repeatNotification &&
        !this.isForceStopSoundEnabled()
    );
  }
}
